import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { HidePopup } from '../../../personne.state';

@Component({
  selector: 'app-popup-propriete-error',
  templateUrl: './popup-propriete-error.component.html',
  standalone: false
})
export class PopupProprieteErrorComponent {
  @Input()
  mode: string;

  constructor(private readonly _store: Store) {}

  close() {
    this._store.dispatch(new HidePopup());
  }
}
